import { useEffect, useState } from 'react';
import Button from '../ui/Button';

type CookieChoice = 'accepted' | 'rejected';

const STORAGE_KEY = 'budgetai_cookie_consent_v1';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) setVisible(true);
  }, []);

  const saveChoice = (choice: CookieChoice) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        choice,
        timestamp: new Date().toISOString(),
      }),
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50">
      <div className="mx-auto max-w-5xl rounded-2xl border border-slate-700 bg-slate-900/95 backdrop-blur p-4 sm:p-5 shadow-2xl">
        <p className="text-sm text-slate-200">
          Utilizziamo cookie tecnici per il funzionamento dell'app e, con il tuo consenso, cookie analitici per migliorare il servizio.
        </p>
        <p className="text-xs text-slate-400 mt-1">
          Puoi cambiare scelta in qualsiasi momento eliminando i cookie del browser.
        </p>

        <div className="mt-4 flex flex-col sm:flex-row gap-2 sm:justify-end">
          <Button variant="ghost" onClick={() => saveChoice('rejected')}>
            Rifiuta analitici
          </Button>
          <Button onClick={() => saveChoice('accepted')}>
            Accetta tutti
          </Button>
        </div>
      </div>
    </div>
  );
}
